export const dayBefore = (d:Date) : Date => {
  return new Date(new Date(d.getTime()).setDate(d.getDate() - 1));
};
